// Django's set_language view sets the session/cookie language and redirects
// to `next`; i18n_patterns then serves that URL with the right prefix on
// the next request. Submitted as a real form POST, not fetch, so the
// redirect is followed natively by the browser.
//
// Shared by every header that offers a language switcher (logistration,
// dashboard, onboarding) — they all hit the same Django endpoint the same way.
export function setLanguage(code, languageCodes) {
    var _a, _b;
    // `next` must have any existing language prefix stripped first — otherwise
    // an explicit prefix in the URL (e.g. /en/login/) overrides the new
    // session language and the switch silently no-ops for non-default languages.
    const codePattern = languageCodes.join('|');
    const currentPath = window.location.pathname + window.location.search;
    let next = currentPath.replace(new RegExp(`^/(${codePattern})(/|$)`), '/');
    // Django's i18n_patterns routes require a trailing slash (e.g. `register/`).
    // Without one, set_language's translate_url() can't resolve `next` to rewrite
    // its language prefix, so it silently redirects to the untranslated path —
    // the language cookie flips but the URL doesn't, and a later APPEND_SLASH
    // redirect lands on the default-language version of the page instead.
    const [pathPart, queryPart] = next.split('?');
    const pathWithSlash = pathPart.endsWith('/') ? pathPart : `${pathPart}/`;
    next = queryPart ? `${pathWithSlash}?${queryPart}` : pathWithSlash;
    const csrfToken = (_b = (_a = document.cookie.match(/csrftoken=([^;]+)/)) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : '';
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/i18n/setlang/';
    const fields = {
        csrfmiddlewaretoken: csrfToken,
        language: code,
        next,
    };
    Object.entries(fields).forEach(([name, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
}
